import IframeInnerLayer from '../layer/IframeInnerLayer';

/**
 * @export
 * @class PartnerInfoForDelivery
 * SPC 딜(베이직 딜+다이렉트딜)의 판매자 정보
 */
export default class PartnerInfoForDelivery {
  constructor() {
    this.welWrapper = $('#_wrapOMInfo');
    this.oIframeInnerLayer = null;

    this.render();
    this.setEvent();
  }

  setEvent() {
    // toggle eventListener 등록
    this.welWrapper.on('click', '[data-role=toggleButton]', this.onClickToggle);
    // 서비스 가입사실 확인 레이어 열기 eventListener 등록
    this.welWrapper.on(
      'click',
      '[data-role=btnShowIframe]',
      this.onClickShowServiceInfoLayer
    );
    // 앱에서 링크 이동 eventListener 등록
    if (TMON.view_mode === 'app') {
      this.welWrapper.on('click', 'a', this.onClickLink);
    }
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off('click', '[data-role=toggleButton]');
      this.welWrapper.off('click', '[data-role=btnShowIframe]');
      if (TMON.view_mode === 'app') {
        this.welWrapper.off('click', 'a');
      }
    }
  }

  /**
   * toggle eventListener
   */
  onClickToggle = e => {
    const target = $(e.currentTarget);
    if (
      !target.hasClass('open') &&
      (!TMON.oApp.htStorage.partnerInfo ||
        TMON.oApp.htStorage.partnerInfo.httpCode !== 200)
    ) {
      TMON.oApp.oApi.fetchApi('partnerInfo');
    }
    target.toggleClass('open');
  };

  /**
   * 서비스 가입사실 확인 레이어 열기 eventListener
   */
  onClickShowServiceInfoLayer = e => {
    if (!this.oIframeInnerLayer) {
      this.oIframeInnerLayer = new IframeInnerLayer();
    }

    this.oIframeInnerLayer.open({
      title: '서비스 가입사실 확인',
      src: $(e.currentTarget).data('href'),
    });

    e.preventDefault();
  };

  /**
   * 앱에서 링크 이동 eventListener
   */
  onClickLink = e => {
    TMON.app.callApp(
      'webview',
      'showNaviWebView',
      '티몬',
      TMON.util.aup($(e.currentTarget).attr('href'), TMON.sAppQuery),
      false,
      false,
      true
    );

    e.preventDefault();
  };

  // 파트너 정보의 타이틀 부분을 그린다. (접혀진 상태)
  // 내용은 onClickToggle에서 fetch 후 update에서 그려진다.
  renderPartnerInfoTitle = () => {
    if (
      TMON.htStaticData.htDealInfo.deliveryInfo &&
      TMON.htStaticData.htDealInfo.deliveryInfo.purchase
      // 직매입 딜은 파트너 정보를 노출하지 않는다.
    ) {
      return null;
    }

    return `
      <div id="_partnerInfo" class="bx_ct partner_info">
        <div class="ct_wrp">
          <button type="button" data-role="toggleButton" class="toggle tit_align_top"><h4>판매자 정보</h4></button>
        </div>
      </div>
    `;
  };

  render() {
    const linkUrl = 'https://www.fss.or.kr/fss/bbs/B0000392/view.do?nttId=63381&viewType=BODY';
    const sHtml = `
      ${this.renderPartnerInfoTitle()}

      <div class="bx_ct">
        <div class="ct_wrp">
          <button type="button" data-role="toggleButton" class="toggle tit_align_top ${'open'}">
            <h4>구매안전서비스고지</h4>
          </button>
          <div class="ct slide-ct">
            <div class="safety_area">
              <p class="txt">본 판매자는 고객님의 안전거래를 위해 관련 법률에 의거하여 티몬의 구매안전서비스를 적용하고 있습니다.</p>
              <dl>
                <dt>결제대금예치업 등록번호 : </dt>
                <dd>02-006-00043</dd>
                <dd class="btn"><button data-role="btnShowIframe" class="btn_confirm" data-href="${linkUrl}">서비스 가입 사실 확인</button></dd>
              </dl>
              <p class="txt">㈜티몬은 통신판매중개자로서 거래당사자가 아니며 입점 판매자가 등록한 상품, 거래정보 및 거래에 대하여 ㈜티몬은 일체의 책임을 지지 않습니다.</p>
            </div>
          </div>
        </div>
      </div>
    `;

    this.welWrapper.html(sHtml);
  }

  update(sStorageKey) {
    switch (sStorageKey) {
      case 'partnerInfo':
        this.renderPartnerInfo();
        break;
      default:
        break;
    }
  }

  getCustomerTelNo({ customerContacts, partnerTpCd }) {
    const DEFAULT_TELNO = '티몬 고객센터 | 1544-6240';
    if (
      // 롯데백화점 MMP 딜 인 경우 TelNo가 티몬 고객센터 번호로 내려옴
      (TMON.htStaticData.htDealInfo.productType === 'LOTTE_DEPARTMENT_STORE' &&
        partnerTpCd === 'MMP') ||
      !customerContacts ||
      customerContacts.length === 0
    )
      return DEFAULT_TELNO;

    const [customerTelNo] = customerContacts.filter(
      model => model.contactCd === 'TELNO' && model.contact
    );
    return customerTelNo && customerTelNo.contact
      ? `${customerTelNo.contact}<br>${DEFAULT_TELNO}`
      : DEFAULT_TELNO;
  }

  getCustomerEmail({ customerContacts }) {
    if (!customerContacts || customerContacts.length === 0) return '';

    const [customerEmail] = customerContacts.filter(
      model => model.contactCd === 'EMAIL' && model.contact
    );
    return customerEmail && customerEmail.contact ? customerEmail.contact : '';
  }

  renderPartnerInfo() {
    const {
      partnerInfo: { data = {} },
    } = TMON.oApp.htStorage;
    const customerEmail = this.getCustomerEmail(data);
    const customerTelNo = this.getCustomerTelNo(data);
    const sHtml = `
      <div class="ct slide-ct">
        <div>
          <table class="tbl_info" cell-spacing="0">
            <colgroup><col style="width: 35%" /></colgroup>
            <tbody>
              ${
                data.ecAccountNm
                  ? `
                  <tr>
                    <th scope="row">상호명</th>
                    <td>${data.ecAccountNm}</td>
                  </tr>
              `
                  : ''
              }
              ${
                data.repNm
                  ? `
                  <tr>
                    <th scope="row">대표자명</th>
                    <td>${data.repNm}</td>
                  </tr>
              `
                  : ''
              }
              ${
                data.commSalesBizReportNo
                  ? `
                  <tr>
                    <th scope="row">통신판매업 신고번호</th>
                    <td>${data.commSalesBizReportNo}</td>
                  </tr>
              `
                  : ''
              }
              ${
                data.bizNo
                  ? `
                  <tr>
                    <th scope="row">사업자 등록 번호</th>
                    <td>${data.bizNo}</td>
                  </tr>
              `
                  : ''
              }
              ${
                data.addr && data.detailAddr
                  ? `
                  <tr>
                    <th scope="row">사업장소재지</th>
                    <td>${data.addr}${data.detailAddr}</td>
                  </tr>
              `
                  : ''
              }
              ${
                customerEmail
                  ? `
                  <tr>
                    <th scope="row">이메일</th>
                    <td>${customerEmail}</td>
                  </tr>
              `
                  : ''
              }
              ${
                customerTelNo
                  ? `
                  <tr>
                    <th scope="row">고객문의 연락처</th>
                    <td>
                        ${customerTelNo}
                    </td>
                  </tr>
              `
                  : ''
              }
            </tbody>
          </table>
        </div>
      </div>
    `;

    $('#_partnerInfo .ct_wrp').append(sHtml);
  }
}
